import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import BunkeyAPI from '../../api/BunkeyAPI'
import { KEY_CODE_ENTER } from '../../utils'
import { Progress, Tooltip, Button, Select, Table, Input, Col, Row, Icon } from 'antd'
import ReactJson from 'react-json-view'
import moment from 'moment'
import { useJsonToCsv } from 'react-json-csv';
import { sendNotification, LIMIT_ROWS_EOS_REPORT } from '../../utils'
import { handleFetchingSauronReport } from '../../actions/ClientAction'


const { saveAsCsv } = useJsonToCsv();
const { Option } = Select
const TOTAL_SECONDS = 15
const INTERVAL = 1
const fields = {
  'client': 'Cliente',
  'action': 'Acción',
  'name': 'Usuario',
  'email': 'Email',
  'updatedAt': 'Fecha',
  'isSuccess': '¿Exitosa?'
}

export class EyeOfSauron extends Component {

  constructor(props) {
    super(props)

    const { intl } = this.props

    this.logTypes = [
      { id: 'ClientController.creat', value: intl.formatMessage({ id: "eye_of_sauron_ClientController.creat" }) },
      { id: 'ClientController.deleteById', value: intl.formatMessage({ id: "eye_of_sauron_ClientController.deleteById" }) },
      { id: 'ClientController.updateById', value: intl.formatMessage({ id: "eye_of_sauron_ClientController.updateById" }) },
      { id: 'GroupController.create', value: intl.formatMessage({ id: "eye_of_sauron_GroupController.create" }) },
      { id: 'GroupController.deleteById', value: intl.formatMessage({ id: "eye_of_sauron_GroupController.deleteById" }) },
      { id: 'GroupController.updateById', value: intl.formatMessage({ id: "eye_of_sauron_GroupController.updateById" }) },
      { id: 'InvitationController.create', value: intl.formatMessage({ id: "eye_of_sauron_InvitationController.create" }) },
      { id: 'InvitationController.validate', value: intl.formatMessage({ id: "eye_of_sauron_InvitationController.validate" }) },
      { id: 'ObjectController.confirm', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.confirm" }) },
      { id: 'ObjectController.create', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.create" }) },
      { id: 'ObjectController.deleteById', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.deleteById" }) },
      { id: 'ObjectController.updateById', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.updateById" }) },
      { id: 'SharedController.create', value: intl.formatMessage({ id: "eye_of_sauron_SharedController.create" }) },
      { id: 'SharedController.createDownloadLink', value: intl.formatMessage({ id: "eye_of_sauron_SharedController.createDownloadLink" }) },
      { id: 'SharedController.validate', value: intl.formatMessage({ id: "eye_of_sauron_SharedController.validate" }) },
      { id: 'UserController.create', value: intl.formatMessage({ id: "eye_of_sauron_UserController.create" }) },
      { id: 'UserController.deleteById', value: intl.formatMessage({ id: "eye_of_sauron_UserController.deleteById" }) },
      
      { id: 'CommentsController.create-audio', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-audio" }) },
      { id: 'CommentsController.create-files', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-files" }) },
      { id: 'CommentsController.create-comment', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-comment" }) },
      { id: 'CommentsController.create-email', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-email" }) },
      { id: 'CommentsController.create-assets-modified', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-assets-modified" }) },
      { id: 'CommentsController.create-assignState', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-assignState" }) },
      { id: 'ObjectController.searcher', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.searcher" }) },	
      { id: 'ObjectController.advancedSearcher', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.advancedSearcher" }) },
      { id: 'CommentsController.assignStateStamps', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.assignStateStamps" }) },	
      { id: 'ObjectController.usersToComment', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.usersToComment" }) },
      { id: 'ObjectController.verifyBeforeCreate', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.verifyBeforeCreate" }) },
      { id: 'AssetVersionController.versionCompare', value: intl.formatMessage({ id: "eye_of_sauron_AssetVersionController.versionCompare" }) },
      { id: 'CommentsController.create-filesTags', value: intl.formatMessage({ id: "eye_of_sauron_CommentsController.create-filesTags" }) },

      { id: 'UserController.updateMe', value: intl.formatMessage({ id: "eye_of_sauron_UserController.updateMe" }) },
      { id: 'ObjectController.getAssetById', value: intl.formatMessage({ id: "eye_of_sauron_ObjectController.getAssetById" }) },
      { id: 'recoveryPassword', value: intl.formatMessage({ id: "eye_of_sauron_recoveryPassword" }) },
      { id: 'signIn', value: intl.formatMessage({ id: "eye_of_sauron_signIn" }) },
      { id: 'userAccessClient', value: intl.formatMessage({ id: "eye_of_sauron_userAccessClient" }) }

    ]	

    this.columns = [
      {
        title: 'Cliente',
        key: 'client',
        render: ({ client }) => client && client.name
          ? client.name
          : ''
      },
      {
        title: 'Acción',
        key: 'action',
        render: ({ action }) => intl.formatMessage({ id: `eye_of_sauron_${action}` })
      },
      {
        title: 'Usuario',
        key: 'name',
        dataIndex: 'name'
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email'
      },
      {
        title: 'Fecha',
        key: 'createdAt',
        render: ({ createdAt }) => `${moment(createdAt).format('DD-MM-YYYY HH:mm:ss')} Hrs`
      },
      {
        title: '¿Exitosa?',
        key: 'isSuccess',
        render: ({ isSuccess }) => isSuccess ? 'Sí' : 'No'
      },
    ]

    this.state = {
      isFetching: true,
      autoRefresh: {
        pidFetch: null,
        pidTime: null,
        count: 0,
        percent: 0,
        on: false
      },
      filter: {
        client: 'all',
        action: 'all',
        name: '',
        email: ''
      },
      page: 1,
      count: 0,
      limit: 10,
      clients: [],
      data: []
    }
  }

  componentDidMount() {
    BunkeyAPI({
      url: `admin/clients?page=1&limit=9999`,
      method: 'GET',
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({
          clients: resp.data.map(r => { return { _id: r._id, name: r.name } })
        }, this.handleGetData)
      }
    }).catch(err => {
      console.log('mount err: ', err)
    })

  }

  handleKeyPress = e => {
    if (e.keyCode === KEY_CODE_ENTER) {
      this.setState({
        isFetching: true,
        page: 1,
      }, this.handleGetData)
    }
  }

  handleGetData = () => {
    const { filter, page, limit } = this.state

    let query = []
    let order = {
      field: ['createdAt'],
      type: 'desc',
      limit: limit,
      page: page
    }

    if (filter.client !== 'all') {
      query = [...query, {
        field: 'client.id',
        type: 'eq',
        value: filter.client
      }]
    }

    if (filter.action !== 'all') {
      query = [...query, {
        field: 'action',
        type: 'eq',
        value: filter.action
      }]
    }

    if (filter.name !== '') {
      query = [...query, {
        field: 'name',
        type: 'regex',
        value: filter.name
      }]
    }

    if (filter.email !== '') {
      query = [...query, {
        field: 'email',
        type: 'regex',
        value: filter.email
      }]
    }

    if (query.length > 0) {
      BunkeyAPI({
        url: `/logs?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`,
        method: 'GET',
      }).then(resp => {
        if (resp.status === 200) {
          this.setState({
            data: resp.data,
            limit: parseInt(resp.headers['x-pagination-limit']),
            count: parseInt(resp.headers['x-pagination-total-count']),
            isFetching: false
          })
        }
      }).catch(err => {
        console.log('error: ', err)
      })
    } else {
      BunkeyAPI({
        url: `/logs?order=${JSON.stringify(order)}`,
        method: 'GET',
      }).then(resp => {
        if (resp.status === 200) {
          this.setState({
            data: resp.data,
            limit: parseInt(resp.headers['x-pagination-limit']),
            count: parseInt(resp.headers['x-pagination-total-count']),
            isFetching: false
          })
        }
      }).catch(err => {
        console.log('error: ', err)
      })
    }
  }

  handleOnClientChange = value => {
    const { filter } = this.state
    this.setState({
      isFetching: true,
      page: 1,
      filter: {
        ...filter,
        client: value
      }
    }, this.handleGetData)
  }

  handleOnActionChange = value => {
    const { filter } = this.state
    this.setState({
      isFetching: true,
      page: 1,
      filter: {
        ...filter,
        action: value
      }
    }, this.handleGetData)
  }

  handleOnInputChange = e => {
    const { filter } = this.state
    this.setState({
      filter: {
        ...filter,
        [e.target.name]: e.target.value,
      }
    })
  }

  handleOnPageChange = value => {
    this.setState({
      isFetching: true,
      page: value
    }, this.handleGetData)
  }

  handleRemoveFilter = key => {
    const { filter } = this.state
    this.setState({
      isFetching: true,
      page: 1,
      filter: {
        ...filter,
        [key]: key === 'client' || key === 'action'
          ? 'all'
          : ''
      }
    }, this.handleGetData)
  }

  handleAutoRefresh = () => {
    const { autoRefresh } = this.state
    let pidFetch = null, pidTime = null

    if (!autoRefresh.on) {
      pidFetch = setInterval(() => {
        this.setState({
          page: 1,
          isFetching: true
        }, this.handleGetData)
      }, TOTAL_SECONDS * 1000)

      pidTime = setInterval(() => {

        this.setState((state, props) => ({
          autoRefresh: {
            ...state.autoRefresh,
            count: (state.autoRefresh.count + 1) === TOTAL_SECONDS
              ? 0
              : state.autoRefresh.count + 1,
            percent: ((state.autoRefresh.count + 1) * 100) / TOTAL_SECONDS
          }
        }))
      }, INTERVAL * 1000)

    } else {
      clearInterval(autoRefresh.pidFetch)
      clearInterval(autoRefresh.pidTime)

      this.setState((state, props) => ({
        autoRefresh: {
          ...state.autoRefresh,
          count: 0,
          percent: 0
        }
      }))
    }

    this.setState((state, props) => ({
      autoRefresh: {
        ...state.autoRefresh,
        on: !state.autoRefresh.on,
        pidFetch,
        pidTime
      }
    }))
  }

  handleFilter = () => {
    this.setState({
      isFetching: true,
    }, this.handleGetData)
  }

  handleExportToFile = () => {
    const { filter, page } = this.state
    const { intl, handleFetchingSauronReport, isFetchingSauronReport } = this.props;

    if (isFetchingSauronReport) {
      sendNotification('warning', intl, intl.formatMessage({ id: 'eye_of_sauron_already_report' }))
    } else {
      let query = []
      let order = {
        field: ['createdAt'],
        type: 'desc',
        limit: LIMIT_ROWS_EOS_REPORT,
        page
      }

      if (filter.client !== 'all') {
        query = [...query, {
          field: 'client.id',
          type: 'eq',
          value: filter.client
        }]
      }

      if (filter.action !== 'all') {
        query = [...query, {
          field: 'action',
          type: 'eq',
          value: filter.action
        }]
      }

      if (filter.name !== '') {
        query = [...query, {
          field: 'name',
          type: 'regex',
          value: filter.name
        }]
      }

      if (filter.email !== '') {
        query = [...query, {
          field: 'email',
          type: 'regex',
          value: filter.email
        }]
      }


      handleFetchingSauronReport(true)
      sendNotification('info', intl, intl.formatMessage({ id: 'eye_of_sauron_processing_report' }))

      BunkeyAPI({
        url: query.length > 0
          ? `/logs?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`
          : `/logs?order=${JSON.stringify(order)}`,
        method: 'GET',
      }).then(resp => {
        handleFetchingSauronReport(false)
        const { data, status } = resp
        if (status === 200) {
          saveAsCsv({
            data: data.map(d => {
              return {
                ...d,
                action: d.action
                  ? intl.formatMessage({ id: `eye_of_sauron_${d.action}` })
                  : '',
                client: d.client && d.client.name
                  ? d.client.name
                  : '',
                isSuccess: d.isSuccess
                  ? 'Si'
                  : 'No',
                name: d.name
                  ? d.name
                  : '',
                updatedAt: `${moment(d.createdAt).format("DD/MM/YYYY")}-${moment(d.createdAt).format("HH:mm:ss")} `
              }
            }),
            fields,
            filename: `Reporte-${moment().utc().local().format('DD-MM-YYYY')} ${moment.tz('America/Santiago').format('HH:mm:ss')}`
          })
        }
      }).catch(err => {
        console.log('error: ', err)
        sendNotification('error', intl, intl.formatMessage({ id: 'eye_of_sauron_report_error' }))
        handleFetchingSauronReport(false)
      })
    }

  }

  render() {
    const { newColor, intl } = this.props
    const { filter, data, clients, count, limit, page, isFetching, autoRefresh } = this.state
    return (
      <React.Fragment>
        <div className="title-bar">
          <div className="container" style={{ borderLeftColor: newColor }} >
            <span>Eye of sauron</span>
            <div style={{ display: 'block', float: 'right', marginRight: 15, marginTop: 10 }}>
              <Tooltip placement="top" title={`Filtrado automático cada ${TOTAL_SECONDS} segundos`}>
                <Button type={autoRefresh.on ? 'primary' : 'default'} onClick={this.handleAutoRefresh} shape="circle" size="small" >
                  <Icon type="sync" spin={autoRefresh.on} />
                </Button>
              </Tooltip>
              <Tooltip placement="top" title={intl.formatMessage({ id: 'download_asset' })}>
                <Button type={'default'} shape="circle" size="small" style={{ marginLeft: '4px' }} onClick={this.handleExportToFile}>
                  <Icon type="download" />
                </Button>
              </Tooltip>
            </div>
            {autoRefresh.on && <Progress showInfo={false} percent={autoRefresh.percent} size="small" status="active" />}
          </div>
        </div>
        <div className="assets-wrapper">
          <div className="container">
            <Row gutter={8} style={{ marginBottom: 10 }}>
              <Col xs={24} sm={24} md={12} lg={6}>
                <p>Cliente <small style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.handleRemoveFilter('client')} >limpiar</small></p>
                <Select defaultValue={filter.client} value={filter.client} onChange={this.handleOnClientChange} style={{ width: '100%' }}>
                  <Option key={'all'}>{intl.formatMessage({ id: "all" })}</Option>
                  {clients.sort((a, b) => (a.value > b.value) ? 1 : -1).map(r => <Option key={r._id}>{r.name}</Option>)}
                </Select>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <p>Acción <small style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.handleRemoveFilter('action')} >limpiar</small></p>
                <Select showSearch={true} defaultValue={filter.action} value={filter.action} onChange={this.handleOnActionChange} style={{ width: '100%' }}>
                  <Option key={'all'}>{intl.formatMessage({ id: "all" })}</Option>
                  {this.logTypes.sort((a, b) => (a.value > b.value) ? 1 : -1).map(r => <Option key={r.id}>{r.value}</Option>)}
                </Select>
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <p>Usuario <small style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.handleRemoveFilter('name')} >limpiar</small></p>
                <Input name='name' placeholder="Usuario" onChange={this.handleOnInputChange} value={filter.name} onKeyDown={this.handleKeyPress} />
              </Col>
              <Col xs={24} sm={24} md={12} lg={6}>
                <p>Email <small style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.handleRemoveFilter('email')} >limpiar</small></p>
                <Input name='email' placeholder="Email" onChange={this.handleOnInputChange} value={filter.email} onKeyDown={this.handleKeyPress} />
              </Col>
            </Row>

            <Table
              rowKey="_id"
              loading={isFetching}
              bordered
              columns={this.columns}
              // scroll={{ x: true, y: true }}
              expandedRowRender={row => <div>
                <p>Request</p> <ReactJson collapsed={true} iconStyle="circle" src={JSON.parse(row.requestBody)} theme="monokai" />
                <p>Response</p> <ReactJson collapsed={true} iconStyle="circle" src={JSON.parse(row.responseBody)} theme="monokai" />
              </div>}
              dataSource={data}
              pagination={{
                current: page,
                pageSize: limit,
                total: count,
                onChange: this.handleOnPageChange
              }}
            />
          </div>
        </div>
      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color
      ? state.authUser.user.color
      : '#2E97CF',
    isFetchingSauronReport: state.client.isFetchingSauronReport,
  }
}

const mapDispatchToProps = {
  handleFetchingSauronReport,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(EyeOfSauron)))
